// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"475":"css/app.6897","7778":"css/admin-app.6897"}[chunkId] + ".css";
};